module.exports = __webpack_public_path__ + "img/positiveEffects.565a893.webp";